module.exports = __webpack_public_path__ + "img/supplyChain-file-L.d57b4e78.png";